"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenSankeyMenuConfigurationNodes = void 0;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const prop_types_1 = __importDefault(require("prop-types"));
const types_1 = require("./types");
const SankeyLayout_1 = require("./SankeyLayout");
const SankeyUtils_1 = require("./SankeyUtils");
const d3 = __importStar(require("d3"));
const fa_1 = require("react-icons/fa");
const react_multi_select_component_1 = require("react-multi-select-component");
const SankeyMenuConfigurationNodesIO_1 = require("./SankeyMenuConfigurationNodesIO");
const SankeyMenuConfigurationNodesAttributes_1 = require("./SankeyMenuConfigurationNodesAttributes");
const SankeyMenuConfigurationNodesLabel_1 = require("./SankeyMenuConfigurationNodesLabel");
const SankeyMenuConfigurationNodesTags_1 = require("./SankeyMenuConfigurationNodesTags");
const SankeyMenuConfigurationNodesTooltip_1 = require("./SankeyMenuConfigurationNodesTooltip");
const d3_textwrap_1 = require("d3-textwrap");
const SankeyDrawFunction_1 = require("./SankeyDrawFunction");
const SankeyNodeEditionPropTypes = {
    t: prop_types_1.default.func.isRequired,
    data: prop_types_1.default.shape(types_1.SankeyDataPropTypes).isRequired,
    set_data: prop_types_1.default.func.isRequired,
    selected_node: prop_types_1.default.shape({ current: prop_types_1.default.shape(types_1.SankeyNodePropTypes).isRequired }).isRequired,
    multi_selected_nodes: prop_types_1.default.shape({ current: prop_types_1.default.arrayOf(prop_types_1.default.shape(types_1.SankeyNodePropTypes).isRequired).isRequired }).isRequired,
    multi_selected_links: prop_types_1.default.shape({ current: prop_types_1.default.arrayOf(prop_types_1.default.shape(types_1.SankeyLinkPropTypes).isRequired).isRequired }).isRequired,
    // style_to_apply: PropTypes.string.isRequired,
    set_style_to_apply: prop_types_1.default.func.isRequired,
    menu_configuration_nodes: prop_types_1.default.arrayOf(prop_types_1.default.element.isRequired).isRequired,
    token: prop_types_1.default.bool.isRequired,
    set_display_link_opacity: prop_types_1.default.func.isRequired,
};
const OpenSankeyMenuConfigurationNodes = (t, data, set_data, multi_selected_nodes, menu_configuration_nodes_attributes, link_io, set_link_io, link_pos, set_link_pos, tab_colored, set_tab_colored, getLinkValue) => {
    const [tags_group_key, set_tags_group_key] = react_1.useState(Object.keys(data.nodeTags).length > 0 ? Object.keys(data.nodeTags)[0] : '');
    const ui = {
        'Attributes': SankeyMenuConfigurationNodesAttributes_1.SankeyMenuConfigurationNodesAttributes(t, menu_configuration_nodes_attributes),
        'Labels': SankeyMenuConfigurationNodesLabel_1.SankeyMenuConfigurationNodesLabel(t, data, set_data, multi_selected_nodes, false, 'default'),
        'Tooltip': SankeyMenuConfigurationNodesTooltip_1.SankeyMenuConfigurationNodesTooltip(t, data, set_data, multi_selected_nodes),
    };
    if (Object.keys(data.nodeTags).length > 0 && data.accordeonToShow.includes('EN')) {
        ui['Tags'] = SankeyMenuConfigurationNodesTags_1.SankeyMenuConfigurationNodesTags(t, data, set_data, multi_selected_nodes, tags_group_key, set_tags_group_key);
    }
    if (multi_selected_nodes.current.length == 1) {
        ui['Entrées Sorties'] = SankeyMenuConfigurationNodesIO_1.SankeyMenuConfigurationNodesIO(t, data, set_data, multi_selected_nodes, link_io, set_link_io, link_pos, set_link_pos, tab_colored, set_tab_colored, getLinkValue);
    }
    return ui;
};
exports.OpenSankeyMenuConfigurationNodes = OpenSankeyMenuConfigurationNodes;
const SankeyNodeEdition = ({ t, data, set_data, selected_node, multi_selected_nodes, multi_selected_links, set_style_to_apply, menu_configuration_nodes, token, set_display_link_opacity }) => {
    const [forceUpdate, setForceUpdate] = react_1.useState(false);
    const node_visible = SankeyDrawFunction_1.node_visible_on_svg();
    const tmpNodes = Object.fromEntries(Object.entries(data.nodes).sort(([, a], [, b]) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)));
    const INITIAL_OPTIONS = Object.values(tmpNodes).filter(d => (data.displayed_node_selector) ? node_visible.includes(d.idNode) : true).map((d) => { return { 'label': d.name, 'value': d.idNode }; });
    const selected = multi_selected_nodes.current.map((d) => { return { 'label': d.name, 'value': d.idNode }; });
    //Renvoie le menu déroulant pour la sélection des noeuds
    const dropdownMultiNode = () => {
        const DD = (react_1.default.createElement("div", { id: 'DD_multi_node' },
            react_1.default.createElement(react_multi_select_component_1.MultiSelect, { valueRenderer: (selected) => {
                    return selected.length ? selected.map(({ label }) => label + ', ') : t('Noeud.NS');
                }, options: INITIAL_OPTIONS, value: selected, overrideStrings: {
                    'selectAll': t('Noeud.TS'),
                }, onChange: (selected) => {
                    const new_sel = selected.map(d => d.value);
                    const m_s = Object.values(data.nodes).filter(d => (new_sel.includes(d.idNode)));
                    multi_selected_nodes.current = m_s;
                    Object.values(data.nodes).forEach(n => d3.select(' .opensankey #' + n.idNode).attr('stroke-width', 0));
                    multi_selected_nodes.current.forEach(n => d3.select(' .opensankey #' + n.idNode).attr('stroke-width', 2));
                    setForceUpdate(!forceUpdate);
                    set_data(Object.assign({}, data));
                }, labelledBy: 'hello' })));
        return DD;
    };
    const add_new_node = () => {
        const { nodes } = data;
        const node = SankeyUtils_1.default_node(data);
        // Méthode pour incrementer idNode
        let idNode = Object.keys(data.nodes).length;
        while (data.nodes['node' + idNode]) {
            idNode = idNode + 1;
        }
        node.idNode = 'node' + idNode;
        node.name = node.idNode;
        if (Object.keys(nodes).length < 5) {
            node.x = Object.keys(nodes).length * 200 + 200;
        }
        else {
            node.x = 200;
        }
        nodes[node.idNode] = node;
        for (const tag_group_key in data.nodeTags) {
            node.tags[tag_group_key] = [];
        }
        //WARNING : le set_multi_select ne semble pas changer les noeuds sélectionnés avant d'appliquer le style
        //set_multi_selected_nodes([node])
        multi_selected_nodes.current = [node];
        // style_to_apply = 'default'
        apply_style_to_nodes();
        set_data(Object.assign({}, data));
    };
    const apply_style_to_nodes = () => {
        multi_selected_nodes.current.map(d => {
            // Delete local value so the used value come from the style
            delete d.local;
        });
        set_data(Object.assign({}, data));
    };
    const style_of_selected_nodes = () => {
        let style_to_display = 'Aucun';
        if (multi_selected_nodes.current.length != 0) {
            style_to_display = multi_selected_nodes.current[0].style;
            let inchangee = true;
            multi_selected_nodes.current.map(d => {
                inchangee = (d.style == style_to_display) ? inchangee : false;
            });
            if (style_to_display != '' && style_to_display !== undefined) {
                return (inchangee) ? SankeyUtils_1.cut_name(data.style_node[style_to_display].name, 20) : 'Multiple style parmi les noeuds sélectionnés';
            }
            else {
                return 'Aucun';
            }
        }
        else {
            return style_to_display;
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { justifyContent: 'center', marginBottom: '5px' } },
            react_1.default.createElement("b", null, t('Flux.pg'))),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Flux.pdl'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 8 },
                react_1.default.createElement(react_bootstrap_1.Form.Select, { value: data.display_style.node_font_family_selected, onChange: (evt) => {
                        data.display_style.node_font_family_selected = evt.target.value;
                        set_data(Object.assign({}, data));
                    } }, data.display_style.font_family.map((d) => {
                    return react_1.default.createElement("option", { style: { fontFamily: d }, key: 'ff-' + d, value: d }, d);
                })))),
        react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { justifyContent: 'center', marginTop: '20px', marginBottom: '5px' } },
            react_1.default.createElement("b", null, t('Noeud.plns'))),
        (token == false && Object.keys(data.nodes).length > 15) ?
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { 'color': 'red' } }, t('Menu.warningLimitNode'))))
            :
                react_1.default.createElement(react_1.default.Fragment, null),
        react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'menu.tooltips.noeud.1', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'menu.tooltips.noeud.1' },
                        t('Menu.tooltips.noeud.plus'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", disabled: token == false && Object.keys(data.nodes).length > 15, onClick: () => {
                            set_style_to_apply('default');
                            add_new_node();
                            apply_style_to_nodes();
                        } },
                        react_1.default.createElement(fa_1.FaPlus, null)))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'menu.tooltips.noeud.2', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'menu.tooltips.noeud.2' },
                        t('Menu.tooltips.noeud.slct'),
                        " ") }, dropdownMultiNode())),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'menu.tooltips.noeud.3', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'menu.tooltips.noeud.3' },
                        t('Menu.tooltips.noeud.rm'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: 'danger-right', 
                        // style={{marginRight: "-1em"}}
                        disabled: multi_selected_nodes.current.length == 0, onClick: () => {
                            multi_selected_nodes.current.map(d => SankeyUtils_1.delete_node(data, d));
                            selected_node.current = SankeyUtils_1.default_node(data);
                            multi_selected_nodes.current = [];
                            // Object.values(data.nodes).forEach( n =>
                            //   d3.select(' .opensankey #' + n.idNode).attr('stroke-width',0)
                            // )
                            // setForceUpdate(!forceUpdate)
                            set_data(Object.assign({}, data));
                        } },
                        react_1.default.createElement(fa_1.FaMinus, null))))),
        react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'menu.tooltips.noeud.4', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'menu.tooltips.noeud.4' },
                        t('Menu.tooltips.noeud.dns'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, type: 'switch', checked: data.displayed_node_selector, onChange: evt => {
                            // const c=evt.target.checkeds
                            data.displayed_node_selector = evt.target.checked;
                            set_data(Object.assign({}, data));
                        } }))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 11 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Menu.dns')))),
        react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null,
                    t('Noeud.Style'),
                    ":")),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                react_1.default.createElement(react_bootstrap_1.Dropdown, null,
                    react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "success", id: "dropdown-basic" }, style_of_selected_nodes()),
                    react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, null,
                        react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                                set_style_to_apply('');
                                multi_selected_nodes.current.map(n => {
                                    n.style = '';
                                });
                                set_data(Object.assign({}, data));
                            } }, 'Aucun'),
                        Object.keys(data.style_node).map((d, i) => {
                            return (react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { key: i, onClick: () => {
                                    set_style_to_apply(d);
                                    multi_selected_nodes.current.map(n => {
                                        n.style = d;
                                    });
                                    set_data(Object.assign({}, data));
                                } }, data.style_node[d].name));
                        })))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'menu.tooltips.noeud.5', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'menu.tooltips.noeud.5' },
                        t('Noeud.tooltips.AS'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: 'info', style: { 'width': '100%' }, onClick: () => {
                            apply_style_to_nodes();
                            set_data(Object.assign({}, data));
                        } }, t('Noeud.AS'))))),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Noeud.Nom'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'menu.tooltips.noeud.6', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'menu.tooltips.noeud.6' },
                        t('Noeud.tooltips.Nom'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.FormControl, { value: (multi_selected_nodes.current.length != 1) ? '' : multi_selected_nodes.current[0].name, onChange: evt => {
                            if (multi_selected_nodes.current.length != 1) {
                                return;
                            }
                            multi_selected_nodes.current[0].name = evt.target.value;
                            const d = multi_selected_nodes.current[0];
                            d3.select(' .opensankey #' + d.idNode + '_text').text(evt.target.value);
                            const wrap = d3_textwrap_1.textwrap()
                                .bounds({ height: 100, width: (SankeyUtils_1.return_value_node(data, d, 'label_box_width') != 0) ? SankeyUtils_1.return_value_node(data, d, 'label_box_width') : 110 })
                                .method('tspans');
                            d3.select(' .opensankey #ggg_' + d.idNode + ' text')
                                .call(wrap);
                            if (!d.x_label || data.show_structure === 'structure') {
                                d3.selectAll(' .opensankey #ggg_' + d.idNode + ' text tspan').attr('dx', 0).attr('x', () => {
                                    const width = +d3.select(' .opensankey #' + d.idNode).attr('width');
                                    if (SankeyUtils_1.return_value_node(data, d, 'label_horiz') == 'middle') {
                                        return width / 2;
                                    }
                                    else if (SankeyUtils_1.return_value_node(data, d, 'label_horiz') == 'right') {
                                        return SankeyUtils_1.return_value_node(data, d, 'label_vert') == 'middle' ? width : 0;
                                    }
                                    else {
                                        return 0;
                                    }
                                });
                            }
                            d3.selectAll(' .opensankey #ggg_' + d.idNode + ' text tspan').attr('dx', 0).attr('x', () => {
                                const width = +d3.select(' .opensankey #' + d.idNode).attr('width');
                                if (d.x_label) {
                                    return d.x_label;
                                }
                                else if (SankeyUtils_1.return_value_node(data, d, 'label_horiz') == 'middle') {
                                    return width / 2;
                                }
                                else if (SankeyUtils_1.return_value_node(data, d, 'label_horiz') == 'right') {
                                    return width;
                                }
                                else {
                                    return 0;
                                }
                            });
                            setForceUpdate(!forceUpdate);
                        }, disabled: (multi_selected_nodes.current.length == 1) ? false : true })))),
        (multi_selected_nodes.current.length !== 0) ? (react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 12 },
                react_1.default.createElement(react_bootstrap_1.Tabs, { defaultActiveKey: "nodes_desc", id: "node_attributes", fill: true }, menu_configuration_nodes.map((c) => {
                    return c;
                })),
                react_1.default.createElement(react_bootstrap_1.ButtonGroup, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'menu.tooltips.noeud.7', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'menu.tooltips.noeud.7' },
                                t('Noeud.tooltips.Reorg'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", style: { 'marginBottom': '3px', 'marginRight': '3px', 'width': '100%', 'height': '50px' }, onClick: () => {
                                    Object.values(data.nodes).filter(f => multi_selected_nodes.current.map(d => d.idNode).includes(f.idNode)).map(d => {
                                        SankeyLayout_1.reorganize_node_inputLinksId(data, d, data.nodes, data.links);
                                        SankeyLayout_1.reorganize_node_outputLinksId(data, d, data.nodes, data.links);
                                    });
                                    set_data(Object.assign({}, data));
                                } }, t('Noeud.Reorg')))),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'menu.tooltips.noeud.8', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'menu.tooltips.noeud.8' },
                                t('Noeud.tooltips.SlctOutLink'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", style: { 'marginBottom': '3px', 'marginRight': '3px', 'width': '100%', 'height': '50px' }, onClick: () => {
                                    multi_selected_links.current = [];
                                    Object.values(data.nodes).filter(f => multi_selected_nodes.current.map(d => d.idNode).includes(f.idNode)).map(d => {
                                        multi_selected_links.current = multi_selected_links.current.concat(Object.values(data.links).filter(l => d.outputLinksId.includes(l.idLink)));
                                        const opacity = SankeyUtils_1.return_value_link(data, multi_selected_links.current[0], 'opacity');
                                        set_display_link_opacity(opacity);
                                    });
                                    multi_selected_links.current.forEach(l => d3.selectAll(' .opensankey #gg_' + l.idLink + ' rect').attr('fill-opacity', '1'));
                                } }, t('Noeud.SlctOutLink')))),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'menu.tooltips.noeud.9', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'menu.tooltips.noeud.9' },
                                t('Noeud.tooltips.SlctInLink'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", style: { 'marginBottom': '3px', 'marginRight': '3px', 'width': '100%', 'height': '50px' }, onClick: () => {
                                    multi_selected_links.current = [];
                                    Object.values(data.nodes).filter(f => multi_selected_nodes.current.map(d => d.idNode).includes(f.idNode)).map(d => {
                                        multi_selected_links.current = multi_selected_links.current.concat(Object.values(data.links).filter(l => d.inputLinksId.includes(l.idLink)));
                                        const opacity = SankeyUtils_1.return_value_link(data, multi_selected_links.current[0], 'opacity');
                                        set_display_link_opacity(opacity);
                                    });
                                    multi_selected_links.current.forEach(l => d3.selectAll(' .opensankey #gg_' + l.idLink + ' rect').attr('fill-opacity', '1'));
                                } }, t('Noeud.SlctInLink')))))))) : (react_1.default.createElement(react_1.default.Fragment, null))));
};
SankeyNodeEdition.propTypes = SankeyNodeEditionPropTypes;
exports.default = SankeyNodeEdition;
